// eslint-disable-next-line no-unused-vars
import dispatchActionForAllModules from '@/src/utils/dispatch-action-for-all-modules'

export const state = {
  questionnaire: null,
  questionarryFlow: null,
  features: null,
}

export const getters = {
  getQuestionnaire: (state) => {
    return state.questionnaire ? state.questionnaire : null
  },
  getQuestionarryFlow: (state) => {
    return state.questionarryFlow ? state.questionarryFlow : null
  },

  getFeatures: (state) => {
    return state.features ? state.features : null
  },
}

export const mutations = {
  SET_QUESTIONNAIRE(state, newValue) {
    state.questionnaire = newValue
  },
  SET_QUESTIONNAIRE_FLOW(state, newValue) {
    state.questionarryFlow = newValue
  },

  SET_FEATURES(state, newValue) {
    state.features = newValue
  },
}

export const actions = {
  setQuestionnaire({ commit, state }, payload) {
    if (payload) {
      commit('SET_QUESTIONNAIRE', payload)
      return payload
    }
    return null
  },
  setQuestionarryFlow({ commit, state }, payload) {
    if (payload) {
      commit('SET_QUESTIONNAIRE_FLOW', payload)
      return payload
    }
    return null
  },
  setFeatures({ commit, state }, payload) {
    if (payload) {
      commit('SET_FEATURES', payload)
      return payload
    }
    return null
  },
}
